import { cineamoApiClient } from '../../apiClient';
import { UrlQueryParameter, buildUrlQuery } from '../../helpers/url-query-helper';
import { SeatRowDto } from '../../models/seat-row/SeatRowDto.types';
import { SeatRowInputDto } from '../../models/seat-row/SeatRowInputDto';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { SeatRowListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

// <------------------------ SeatRows ------------------------>

type GetSeatRowsParams = UrlQueryParameter & {
    cinemaRoomId?: number;
    name?: string;
};

export async function getSeatRows(urlParams?: GetSeatRowsParams): Promise<ApiResponse<SeatRowListResponse>> {
    return cineamoApiClient
        .get<ApiResponse<SeatRowListResponse>>(`/seat-rows${buildUrlQuery(urlParams)}`)
        .then((response) => response.data)
        .catch(() => null);
}

// <------------------------ SeatRow ------------------------>

export async function getSeatRowById(id: SeatRowDto['id']): Promise<ApiResponse<SeatRowDto>> {
    return cineamoApiClient
        .get<ApiResponse<SeatRowDto>>(`/seat-rows/${id}`)
        .then((response) => response.data)
        .catch(() => null);
}

// <------------------------ Create SeatRow ------------------------>

export async function createSeatRow(
    seatRow: SeatRowInputDto
): Promise<ApiResponse<SeatRowDto> | ApiErrorResponse<SeatRowInputDto>> {
    return cineamoApiClient
        .post('/seat-rows', seatRow)
        .then((response) => response.data)
        .catch((error) => error);
}

// <------------------------ Update SeatRow ------------------------>

export async function updateSeatRowById(
    seatRowId: number,
    seatRow: SeatRowInputDto
): Promise<ApiResponse<SeatRowDto> | ApiErrorResponse<SeatRowInputDto>> {
    return cineamoApiClient
        .patch(`/seat-rows/${seatRowId}`, seatRow)
        .then((response) => response.data)
        .catch((error) => error);
}

// <------------------------ Delete SeatRow ------------------------>

export async function deleteSeatRowById(seatRowId: number): Promise<boolean> {
    return cineamoApiClient
        .delete(`/seat-rows/${seatRowId}`)
        .then((response) => response.status === 204)
        .catch(() => false);
}
